import { render, staticRenderFns } from "./videoDetails.vue?vue&type=template&id=5b4022fc&scoped=true&"
import script from "./videoDetails.vue?vue&type=script&lang=js&"
export * from "./videoDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoDetails.vue?vue&type=style&index=0&id=5b4022fc&prod&scoped=true&lang=scss&"
import style1 from "./videoDetails.vue?vue&type=style&index=1&id=5b4022fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4022fc",
  null
  
)

export default component.exports